import { FitterEditProfile } from 'feature/user/components/FitterEditProfile'
import { MainLayout } from 'layouts'

export const LkmProfileEditPage = () => {
  return (
    <MainLayout>
      <div className='container'>
        <FitterEditProfile />
      </div>
    </MainLayout>
  )
}
